export const AMAZON_TRANSCRIBE_S3_VALIDATION_ERROR = "amazon_transcribe_s3_validation_failed";
export const AMAZON_TRANSCRIBE_API_VALIDATION_ERROR = "amazon_transcribe_api_validation_failed";
